import { supabase } from "@internal/supabase-client";
import type { Session, User } from "@supabase/supabase-js";
import { BehaviorSubject } from "rxjs";

export interface SessionState {
  user: User | null;
  loading: boolean;
}

const internalState$ = new BehaviorSubject<SessionState>({
  user: null,
  loading: true,
});

export const state$ = internalState$.asObservable();

export function snapshot(): SessionState {
  return internalState$.getValue();
}

function applyEvent(event: string, session: Session | null): void {
  if (event === "INITIAL_SESSION" || event === "SIGNED_IN") {
    internalState$.next({ user: session?.user ?? null, loading: false });
  } else if (event === "SIGNED_OUT") {
    internalState$.next({ user: null, loading: false });
  } else if (event === "TOKEN_REFRESHED" || event === "USER_UPDATED") {
    internalState$.next({ user: session?.user ?? null, loading: false });
  }
}

supabase.auth.onAuthStateChange((event, session) => {
  applyEvent(event, session);
});
